import React from 'react';
import { hydrate } from 'react-dom';
import App from './app';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eb/site-analytics';
import { getLocaleOverride, setupAsync, getParentLocale } from '@eb/i18n';

import { loadableReady } from '@loadable/component';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || {};
const parentLocale = getParentLocale(
    getLocaleOverride() || props.env.localeInfo.locale,
);

if (parentLocale !== 'en_US') {
    setupAsync({
        parentLocale,
        translations: /* webpackChunkName: "i18n-translation" */ import(
            `./i18n/translations/${parentLocale}.json`
        ),
    });
}

// render app with server props to the DOM
loadableReady(() => {
    hydrate(<App {...props} />, document.getElementById('root'));
});

initDimensionsFromState(props);
trackInitialPageView(props.gaSettings);
